import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArOM: CultureInfo = {
  name: 'ar-OM',
  displayName: 'Arabic (Oman)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-OM',
  parent: CultureInfoAr
};
